import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';
import {SCHEMA_INTERFACES_BASE_URL} from 'schemas/schema-interface/SchemaInterfaceDAO';

export const SchemasRoutes: RouteBundle = {
  domain: 'schemas',
  routes: [
    {urlPattern: 'schema-policies', handler: schemaPoliciesPage, legacy: true},
    {urlPattern: 'schema-policies/policies', handler: schemaPoliciesPage, legacy: true},
    {
      urlPattern: 'schema-policies/settings',
      handler: EditorRoutes.schemaPoliciesPageSettingsTab.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'schema-policies/:policyId', handler: schemaPolicyPage, legacy: true},
    // TODO (BNCH-97690): Remove the hardcoded 'schema-interfaces' routes
    {
      urlPattern: 'schema-interfaces/',
      handler: EditorRoutes.schemaInterfaces.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'schema-interfaces/create',
      handler: EditorRoutes.schemaInterfaceCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'schema-interfaces/:interfaceId',
      handler: EditorRoutes.schemaInterfaceSettings.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: `${SCHEMA_INTERFACES_BASE_URL}/`,
      handler: EditorRoutes.schemaInterfaces.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: `${SCHEMA_INTERFACES_BASE_URL}/create`,
      handler: EditorRoutes.schemaInterfaceCreate.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: `${SCHEMA_INTERFACES_BASE_URL}/:interfaceId`,
      handler: EditorRoutes.schemaInterfaceSettings.bind(EditorRoutes),
      legacy: false,
    },
  ],
};

function schemaPoliciesPage(): void {
  EditorRoutes.schemaPoliciesPage();
}

function schemaPolicyPage(schemaPolicyId: string): void {
  EditorRoutes.schemaPolicyPage(schemaPolicyId);
}
